import React from 'react'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import Menu from "../menu/Menu";

import { Outlet } from 'react-router-dom'

export default function Layout(prop) {
      const isMobile = window.innerWidth <= 768;

  return (
    <div>
      <>{isMobile ? <Menu /> : <Navbar />}</>
      <Outlet />
      <Footer />
    </div>
  );
}
